export interface IMinMax {
  min: number;
  max: number;
}

export enum EMemberChoicesLabels {
  alcoholHabit = 'alcoholHabit',
  childNumber = 'childNumber',
  childsAtHome = 'childsAtHome',
  childsAtHomeWeighting = 'childsAtHomeWeighting',
  profileBodyShape = 'profileBodyShape',
  profileChildrenWish = 'profileChildrenWish',
  profileEthnicity = 'profileEthnicity',
  profileEthnicityNotice = 'profileEthnicityNotice',
  profileEyes = 'profileEyes',
  profileFoodHabit = 'profileFoodHabit',
  profileHairColor = 'profileHairColor',
  profileHairStyle = 'profileHairStyle',
  profileHeight = 'profileHeight',
  profileHobbies = 'profileHobbies',
  profileIncome = 'profileIncome',
  profileJob = 'profileJob',
  profileLanguage = 'profileLanguage',
  profileLeisure = 'profileLeisure',
  profileMaritalStatus = 'profileMaritalStatus',
  profileNationality = 'profileNationality',
  profilePet = 'profilePet',
  profileReligion = 'profileReligion',
  profileReligionNotice = 'profileReligionNotice',
  profileReligionBehaviour = 'profileReligionBehaviour',
  profileReligionBehaviourNotice = 'profileReligionBehaviourNotice',
  profileSmokeHabit = 'profileSmokeHabit',
  profileSports = 'profileSports',
  profileStudies = 'profileStudies',
  profileWeight = 'profileWeight',
  searchEthnicity = 'searchEthnicity',
  searchEthnicityWeighting = 'searchEthnicityWeighting',
  searchAge = 'searchAge',
  searchHeight = 'searchHeight',
  searchProximity = 'searchProximity',
  searchReligion = 'searchReligion',
  searchReligionBehaviour = 'searchReligionBehaviour',
  searchReligionWeighting = 'searchReligionWeighting',
  searchSmokeHabit = 'searchSmokeHabit',
  searchSmokeHabitWeighting = 'searchSmokeHabitWeighting',
  searchStudies = 'searchStudies',
  searchStudiesWeighting = 'searchStudiesWeighting',
  selftestAboutLove = 'selftestAboutLove',
  selftestAccomodatingOppose = 'selftestAccomodatingOppose',
  selftestAchieveGoals = 'selftestAchieveGoals',
  selftestAdaptChallenges = 'selftestAdaptChallenges',
  selftestAdaptChange = 'selftestAdaptChange',
  selftestAltruisticness = 'selftestAltruisticness',
  selftestApproachStranger = 'selftestApproachStranger',
  selftestArtisticStyle = 'selftestArtisticStyle',
  selftestBeingHappy = 'selftestBeingHappy',
  selftestBeingTheOne = 'selftestBeingTheOne',
  selftestBestFriendIssue = 'selftestBestFriendIssue',
  selftestCalmEnergetic = 'selftestCalmEnergetic',
  selftestCarePeople = 'selftestCarePeople',
  selftestChildrenBalancedDiet = 'selftestChildrenBalancedDiet',
  selftestChildrenEducation = 'selftestChildrenEducation',
  selftestClothingStyle = 'selftestClothingStyle',
  selftestCommonIntrests = 'selftestCommonIntrests',
  selftestCompulsiveShopping = 'selftestCompulsiveShopping',
  selftestConfidentShy = 'selftestConfidentShy',
  selftestContradictBehaviour = 'selftestContradictBehaviour',
  selftestCoupleVision = 'selftestCoupleVision',
  selftestDecisionMaking = 'selftestDecisionMaking',
  selftestDecisionUnderInfluence = 'selftestDecisionUnderInfluence',
  selftestDirection = 'selftestDirection',
  selftestDirectSubtle = 'selftestDirectSubtle',
  selftestDislikeChange = 'selftestDislikeChange',
  selftestDreamerRational = 'selftestDreamerRational',
  selftestEfficientRelaxed = 'selftestEfficientRelaxed',
  selftestEnjoysLife = 'selftestEnjoysLife',
  selftestExtrovertIntrovert = 'selftestExtrovertIntrovert',
  selftestFamilyLife = 'selftestFamilyLife',
  selftestFamilyRelationship = 'selftestFamilyRelationship',
  selftestFamilyTies = 'selftestFamilyTies',
  selftestFeelingFree = 'selftestFeelingFree',
  selftestFidelity = 'selftestFidelity',
  selftestFilm = 'selftestFilm',
  selftestFirstSight = 'selftestFirstSight',
  selftestFreeTime = 'selftestFreeTime',
  selftestFriendsAppreciate = 'selftestFriendsAppreciate',
  selftestFriendsLikes = 'selftestFriendsLikes',
  selftestFutureVision = 'selftestFutureVision',
  selftestHarmoniousRelationship = 'selftestHarmoniousRelationship',
  selftestHoldGrudges = 'selftestHoldGrudges',
  selftestHolidayDestination = 'selftestHolidayDestination',
  selftestHomebirdParty = 'selftestHomebirdParty',
  selftestInControl = 'selftestInControl',
  selftestInstinctiveReflective = 'selftestInstinctiveReflective',
  selftestInterests = 'selftestInterests',
  selftestInteriorDesign = 'selftestInteriorDesign',
  selftestLifeColor = 'selftestLifeColor',
  selftestLifeMindset = 'selftestLifeMindset',
  selftestLiveEnjoyMyself = 'selftestLiveEnjoyMyself',
  selftestLongTermProjects = 'selftestLongTermProjects',
  selftestLongTermRelationship = 'selftestLongTermRelationship',
  selftestLoveVision = 'selftestLoveVision',
  selftestMakeLaugh = 'selftestMakeLaugh',
  selftestMethodicalSpontaneous = 'selftestMethodicalSpontaneous',
  selftestMoneyImportance = 'selftestMoneyImportance',
  selftestMoneyMeans = 'selftestMoneyMeans',
  selftestMusicStyle = 'selftestMusicStyle',
  selftestOrganized = 'selftestOrganized',
  selftestOtherOpinions = 'selftestOtherOpinions',
  selftestParentChildRelationship = 'selftestParentChildRelationship',
  selftestPartnerClothingTaste = 'selftestPartnerClothingTaste',
  selftestPartnerCouncil = 'selftestPartnerCouncil',
  selftestPartnerHabits = 'selftestPartnerHabits',
  selftestPartnerPersonality = 'selftestPartnerPersonality',
  selftestPartnerSupport = 'selftestPartnerSupport',
  selftestPartyOrganizer = 'selftestPartyOrganizer',
  selftestPersonalAttitude = 'selftestPersonalAttitude',
  selftestPersonality = 'selftestPersonality',
  selftestPersonalTimeOut = 'selftestPersonalTimeOut',
  selftestProblemAdvice = 'selftestProblemAdvice',
  selftestPromotionManagement = 'selftestPromotionManagement',
  selftestRelationshipSexuality = 'selftestRelationshipSexuality',
  selftestRelaxingEvening = 'selftestRelaxingEvening',
  selftestReligion = 'selftestReligion',
  selftestReligionContact = 'selftestReligionContact',
  selftestRelyOnExperience = 'selftestRelyOnExperience',
  selftestRespectValues = 'selftestRespectValues',
  selftestRiskManagement = 'selftestRiskManagement',
  selftestRomanticGestures = 'selftestRomanticGestures',
  selftestSaverSpender = 'selftestSaverSpender',
  selftestSexDrive = 'selftestSexDrive',
  selftestSexLife = 'selftestSexLife',
  selftestSharedCulturalReferences = 'selftestSharedCulturalReferences',
  selftestSharedDecisionsMaking = 'selftestSharedDecisionsMaking',
  selftestSocietyBehaviour = 'selftestSocietyBehaviour',
  selftestSpecificRoles = 'selftestSpecificRoles',
  selftestSpirituality = 'selftestSpirituality',
  selftestTakingRisks = 'selftestTakingRisks',
  selftestTalkInvolvement = 'selftestTalkInvolvement',
  selftestThoughtSharing = 'selftestThoughtSharing',
  selftestTravellingExploring = 'selftestTravellingExploring',
  selftestTreeShade = 'selftestTreeShade',
  selftestWorkLifeBalance = 'selftestWorkLifeBalance',
  selftestWorrying = 'selftestWorrying',
  sociotestBodyPartAttraction = 'sociotestBodyPartAttraction',
  sociotestFilm = 'sociotestFilm',
  sociotestLittleWeakness = 'sociotestLittleWeakness',
  sociotestLivingIn = 'sociotestLivingIn',
  sociotestLook = 'sociotestLook',
  sociotestLuxuryDefinition = 'sociotestLuxuryDefinition',
  sociotestMakeMeHappy = 'sociotestMakeMeHappy',
  sociotestMusicStyle = 'sociotestMusicStyle',
  sociotestQualityTime = 'sociotestQualityTime',
  sociotestReceptionCooking = 'sociotestReceptionCooking',
  sociotestStressManagment = 'sociotestStressManagment',
}

export type TMemberAnswerValue = number[] | IMinMax;

//childNumber => 1 if none, 2 if 1 child, 3 if 2 children, 4 if more than 2 children
export enum childNumberValue {
  none = 1,
  one = 2,
  two = 3,
  moreThanTwo = 4,
}

// looking for child at home --> 0 if not looking for child, 1 if looking for child
export enum childsAtHomeValue {
  no = 0, // happens only for "i keep it for myself" ? should not happen in Affiny
  yes = 1,
  no_legacy = 2,
}

// on profileSmokeHabit => 1 for never, 2 for just a bit, 3 only for big events, 4 regularly, 5 very often
export enum profileSmokeHabbitValue {
  never = 1,
  rarely = 2,
  sometimes = 3,
  regularly = 4,
  everyDay = 5,
}

// looking for somoeone smoking => 6 is yes, 7 if no
export enum searchSmokeHabitValue {
  notSmoking = 7,
  smoking = 6,
}

export enum importanceValue {
  notImportant = 1,
  important = 2,
  veryImportant = 3,
}

export enum searchEthnicityValue {
  european = 1,
  african = 2,
  arabic = 3,
  asian = 4,
  hipanic = 5,
  other = 6,
  indian = 7, // (no comment on Indian coming after Other... WT*)
}

export interface IMemberChoices
  extends Partial<Record<EMemberChoicesLabels, TMemberAnswerValue>> {
  alcoholHabit?: number[];
  childNumber?: childNumberValue[];
  childsAtHome?: childsAtHomeValue[];
  childsAtHomeWeighting?: number[];
  profileBodyShape?: number[];
  profileChildrenWish?: number[];
  profileEthnicity?: number[];
  profileEyes?: number[];
  profileFoodHabit?: number[];
  profileHairColor?: number[];
  profileHairStyle?: number[];
  profileHeight?: number[];
  profileHobbies?: number[];
  profileIncome?: number[];
  profileJob?: number[];
  profileLanguage?: number[];
  profileLeisure?: number[];
  profileMaritalStatus?: number[];
  profileNationality?: number[];
  profilePet?: number[];
  profileReligion?: number[];
  profileReligionBehaviour?: number[];
  profileSmokeHabit?: number[];
  profileSports?: number[];
  profileStudies?: number[];
  profileWeight?: number[];
  searchAge?: IMinMax;
  searchEthnicity?: number[];
  searchEthnicityWeighting?: number[];
  searchHeight?: IMinMax;
  searchReligion?: number[];
  searchReligionBehaviour?: number[];
  searchReligionWeighting?: number[];
  searchSmokeHabit?: number[];
  searchSmokeHabitWeighting?: number[];
  searchStudies?: number[];
  searchStudiesWeighting?: number[];
  selftestAboutLove?: number[];
  selftestAccomodatingOppose?: number[];
  selftestAchieveGoals?: number[];
  selftestAdaptChallenges?: number[];
  selftestAdaptChange?: number[];
  selftestAltruisticness?: number[];
  selftestApproachStranger?: number[];
  selftestArtisticStyle?: number[];
  selftestBeingHappy?: number[];
  selftestBeingTheOne?: number[];
  selftestBestFriendIssue?: number[];
  selftestCalmEnergetic?: number[];
  selftestCarePeople?: number[];
  selftestChildrenBalancedDiet?: number[];
  selftestChildrenEducation?: number[];
  selftestClothingStyle?: number[];
  selftestCommonIntrests?: number[];
  selftestCompulsiveShopping?: number[];
  selftestConfidentShy?: number[];
  selftestContradictBehaviour?: number[];
  selftestCoupleVision?: number[];
  selftestDecisionMaking?: number[];
  selftestDecisionUnderInfluence?: number[];
  selftestDirection?: number[];
  selftestDirectSubtle?: number[];
  selftestDislikeChange?: number[];
  selftestDreamerRational?: number[];
  selftestEfficientRelaxed?: number[];
  selftestEnjoysLife?: number[];
  selftestExtrovertIntrovert?: number[];
  selftestFamilyLife?: number[];
  selftestFamilyRelationship?: number[];
  selftestFamilyTies?: number[];
  selftestFeelingFree?: number[];
  selftestFidelity?: number[];
  selftestFilm?: number[];
  selftestFirstSight?: number[];
  selftestFreeTime?: number[];
  selftestFriendsAppreciate?: number[];
  selftestFriendsLikes?: number[];
  selftestFutureVision?: number[];
  selftestHarmoniousRelationship?: number[];
  selftestHoldGrudges?: number[];
  selftestHolidayDestination?: number[];
  selftestHomebirdParty?: number[];
  selftestInControl?: number[];
  selftestInstinctiveReflective?: number[];
  selftestInterests?: number[];
  selftestInteriorDesign?: number[];
  selftestLifeColor?: number[];
  selftestLifeMindset?: number[];
  selftestLiveEnjoyMyself?: number[];
  selftestLongTermProjects?: number[];
  selftestLongTermRelationship?: number[];
  selftestLoveVision?: number[];
  selftestMakeLaugh?: number[];
  selftestMethodicalSpontaneous?: number[];
  selftestMoneyImportance?: number[];
  selftestMoneyMeans?: number[];
  selftestMusicStyle?: number[];
  selftestOrganized?: number[];
  selftestOtherOpinions?: number[];
  selftestParentChildRelationship?: number[];
  selftestPartnerClothingTaste?: number[];
  selftestPartnerCouncil?: number[];
  selftestPartnerHabits?: number[];
  selftestPartnerPersonality?: number[];
  selftestPartnerSupport?: number[];
  selftestPartyOrganizer?: number[];
  selftestPersonalAttitude?: number[];
  selftestPersonality?: number[];
  selftestPersonalTimeOut?: number[];
  selftestProblemAdvice?: number[];
  selftestPromotionManagement?: number[];
  selftestRelationshipSexuality?: number[];
  selftestRelaxingEvening?: number[];
  selftestReligion?: number[];
  selftestReligionContact?: number[];
  selftestRelyOnExperience?: number[];
  selftestRespectValues?: number[];
  selftestRiskManagement?: number[];
  selftestRomanticGestures?: number[];
  selftestSaverSpender?: number[];
  selftestSexDrive?: number[];
  selftestSexLife?: number[];
  selftestSharedCulturalReferences?: number[];
  selftestSharedDecisionsMaking?: number[];
  selftestSocietyBehaviour?: number[];
  selftestSpecificRoles?: number[];
  selftestSpirituality?: number[];
  selftestTakingRisks?: number[];
  selftestTalkInvolvement?: number[];
  selftestThoughtSharing?: number[];
  selftestTravellingExploring?: number[];
  selftestTreeShade?: number[];
  selftestWorkLifeBalance?: number[];
  selftestWorrying?: number[];
  sociotestBodyPartAttraction?: number[];
  sociotestFilm?: number[];
  sociotestLittleWeakness?: number[];
  sociotestLivingIn?: number[];
  sociotestLook?: number[];
  sociotestLuxuryDefinition?: number[];
  sociotestMakeMeHappy?: number[];
  sociotestMusicStyle?: number[];
  sociotestQualityTime?: number[];
  sociotestReceptionCooking?: number[];
  sociotestStressManagment?: number[];
}

export interface IApiMemberChoice {
  type: 'memberchoice';
  id: string;
  attributes: Partial<IMemberChoices>;
}
